import { cn } from '@/lib/cn';

/**
 * Setup-wizard unit: the one progress meter for the whole journey — the
 * signup wizard shows flow position ("Setting up your fleet — step 3 of 5")
 * and the in-app first-run header shows checklist completion
 * ("Setup — 3 of 5 done"). Same visual, two honest labels: the denominators
 * differ (5 wizard steps vs 5 checklist items) so one literal counter would
 * misrepresent one of them.
 */
export function SetupMeter({
  label,
  current,
  total,
  className,
}: {
  /** Full text, e.g. "Setting up your fleet — step 3 of 5". */
  label: string;
  current: number;
  total: number;
  className?: string;
}) {
  const pct = Math.max(0, Math.min(100, Math.round((current / total) * 100)));
  return (
    <div className={cn('space-y-1.5', className)}>
      <p className="text-xs font-medium text-breaker-ink-2">{label}</p>
      <div
        role="progressbar"
        aria-valuenow={current}
        aria-valuemin={0}
        aria-valuemax={total}
        aria-label={label}
        className="h-1.5 w-full rounded-full bg-breaker-line overflow-hidden"
      >
        <div
          className="h-full rounded-full bg-breaker-identity transition-all duration-300"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
